// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoGraphickBlock_sectionBanner__aO23U{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.InfoGraphickBlock_sectionBannerContainer__BfOHU{
    max-width: 1110px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 60px;
}
.InfoGraphickBlock_infographicContainer__iemU2{
    max-width: 1110px;
    width: 100%;
    height: 100%;
}
.InfoGraphickBlock_infographicContainer__iemU2 img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/pages/Services/sections/InfoGraphickBlock/InfoGraphickBlock.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".sectionBanner{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n.sectionBannerContainer{\n    max-width: 1110px;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 60px;\n}\n.infographicContainer{\n    max-width: 1110px;\n    width: 100%;\n    height: 100%;\n}\n.infographicContainer img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionBanner": `InfoGraphickBlock_sectionBanner__aO23U`,
	"sectionBannerContainer": `InfoGraphickBlock_sectionBannerContainer__BfOHU`,
	"infographicContainer": `InfoGraphickBlock_infographicContainer__iemU2`
};
export default ___CSS_LOADER_EXPORT___;
